import * as AgGrid from 'ag-grid-enterprise'
const { LicenseManager } = AgGrid
LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID_LICENSE_KEY)
